<h2 mat-dialog-title>
  <span>Informe o e-mail para envio</span>
  <button class="dna-dialog-close" mat-dialog-close title="Fechar">&times;</button>
</h2>
<mat-dialog-content>
  <p class="mt-3">Qual e-mail deseja receber o relatório do extrato de consumo?</p>
  <div class="dna-form-field mt-2">
    <label class="dna-label">E-mail</label>
    <input class="dna-input" [(ngModel)]="email" type="email">
  </div>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: flex-end; gap:8px;">
  <button class="dna-btn-ghost" (click)="onNoClick()">Cancelar</button>
  <button class="dna-btn-orange" [mat-dialog-close]="email" cdkFocusInitial>Confirmar</button>
</mat-dialog-actions>
